import React from 'react';
import Pill from '@/app/common/components/Pill/index.tsx';
import { Badge } from '@/app/components/search/components/NoResults/BadgesContainer/styled.ts';
import { CloseIcon } from '@/app/components/search/components/NoResults/BadgesContainer/Badges.tsx';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';

export type handleFilterClicked = () => void;

type FilterBadgeStandardProps = {
  label: string | React.ReactElement | React.ReactElement[];
  handleFilterClicked: handleFilterClicked;
  isLoading?: boolean;
};

export const FilterBadgeContent = ({ label, handleFilterClicked, isLoading }: FilterBadgeStandardProps) => {
  const { useEvoFilters } = useFiltersUiData();

  if (!useEvoFilters)
    return (
      <Badge
        onClick={isLoading ? undefined : handleFilterClicked}
        aria-disabled={isLoading || undefined}
        key={`${label}`}
      >
        {label}
        &nbsp;
        <CloseIcon />
      </Badge>
    );

  return (
    <Pill
      label={Array.isArray(label) ? <span>{label}</span> : label}
      selected={true}
      isLoading={false}
      busy={isLoading}
      isOpen={false}
      showArrow={false}
      handleClick={handleFilterClicked}
      handleDelete={handleFilterClicked}
    />
  );
};
